import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::index
* @see app/Http/Controllers/Admin/Platform/LeadController.php:56
* @route '/admin/leads'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/leads',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::index
* @see app/Http/Controllers/Admin/Platform/LeadController.php:56
* @route '/admin/leads'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::index
* @see app/Http/Controllers/Admin/Platform/LeadController.php:56
* @route '/admin/leads'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::index
* @see app/Http/Controllers/Admin/Platform/LeadController.php:56
* @route '/admin/leads'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::index
* @see app/Http/Controllers/Admin/Platform/LeadController.php:56
* @route '/admin/leads'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::index
* @see app/Http/Controllers/Admin/Platform/LeadController.php:56
* @route '/admin/leads'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::index
* @see app/Http/Controllers/Admin/Platform/LeadController.php:56
* @route '/admin/leads'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::bulkDestroy
* @see app/Http/Controllers/Admin/Platform/LeadController.php:39
* @route '/admin/leads/bulk-destroy'
*/
export const bulkDestroy = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkDestroy.url(options),
    method: 'post',
})

bulkDestroy.definition = {
    methods: ["post"],
    url: '/admin/leads/bulk-destroy',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::bulkDestroy
* @see app/Http/Controllers/Admin/Platform/LeadController.php:39
* @route '/admin/leads/bulk-destroy'
*/
bulkDestroy.url = (options?: RouteQueryOptions) => {
    return bulkDestroy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::bulkDestroy
* @see app/Http/Controllers/Admin/Platform/LeadController.php:39
* @route '/admin/leads/bulk-destroy'
*/
bulkDestroy.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkDestroy.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::bulkDestroy
* @see app/Http/Controllers/Admin/Platform/LeadController.php:39
* @route '/admin/leads/bulk-destroy'
*/
const bulkDestroyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkDestroy.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::bulkDestroy
* @see app/Http/Controllers/Admin/Platform/LeadController.php:39
* @route '/admin/leads/bulk-destroy'
*/
bulkDestroyForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkDestroy.url(options),
    method: 'post',
})

bulkDestroy.form = bulkDestroyForm

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::destroy
* @see app/Http/Controllers/Admin/Platform/LeadController.php:22
* @route '/admin/leads/{lead}'
*/
export const destroy = (args: { lead: string | number } | [lead: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/leads/{lead}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::destroy
* @see app/Http/Controllers/Admin/Platform/LeadController.php:22
* @route '/admin/leads/{lead}'
*/
destroy.url = (args: { lead: string | number } | [lead: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { lead: args }
    }

    if (Array.isArray(args)) {
        args = {
            lead: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        lead: args.lead,
    }

    return destroy.definition.url
            .replace('{lead}', parsedArgs.lead.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::destroy
* @see app/Http/Controllers/Admin/Platform/LeadController.php:22
* @route '/admin/leads/{lead}'
*/
destroy.delete = (args: { lead: string | number } | [lead: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::destroy
* @see app/Http/Controllers/Admin/Platform/LeadController.php:22
* @route '/admin/leads/{lead}'
*/
const destroyForm = (args: { lead: string | number } | [lead: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Platform\LeadController::destroy
* @see app/Http/Controllers/Admin/Platform/LeadController.php:22
* @route '/admin/leads/{lead}'
*/
destroyForm.delete = (args: { lead: string | number } | [lead: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const leads = {
    index: Object.assign(index, index),
    bulkDestroy: Object.assign(bulkDestroy, bulkDestroy),
    destroy: Object.assign(destroy, destroy),
}

export default leads